import React from 'react'

const Footer = () => {
  return (
    <>
      <div className='w-full text-center md:text-left py-3 px-4 bg-white '>
        <div className='flex-wrap'>
          <h1>Copyright @ 2022 <span className='text-blue-600'> Intelzy Software Company. </span>All rights reserved.</h1>
        </div>
      </div>
    </>
  )
}

export default Footer
